import {
  Box,
  Button,
  SpaceBetween,
  TableProps,
} from "@cloudscape-design/components-themed";
import { COMMON_LABELS } from "../default-constants";
import {
  APPLICATION_TYPE_STORES,
  IOrderTargetItems,
  LABELS,
} from "./constants";
import { useNavigate, useParams } from "react-router-dom";
import ExaminationInfo from "./ExaminationInfo";
import ReexaminationInstruction from "./ReexaminationInstruction";
import { getDisplayExaminationOrderTargetStatus } from "./util";
import ExaminationResultsJudgement from "./ExaminationResultsJudgement";
import { useGetReexaminationOrdersQuery } from "../../features/api";
import { useAppDispatch } from "../../app/hook";
import { useLayoutEffect, useEffect } from "react";
import { addNotification } from "../../features/error/notifications-slice";

const columnDefinitions: TableProps.ColumnDefinition<IOrderTargetItems>[] = [
  {
    id: "orderTarget",
    header: LABELS.ORDER_TARGET,
    cell: (item: IOrderTargetItems) => item.orderTarget,
  },
  {
    id: "requestDate",
    header: LABELS.REQUEST_DATE,
    cell: (item: IOrderTargetItems) => item.requestDate,
  },
  {
    id: "examinationOrderTargetStatus",
    header: LABELS.EXAMINATION_ORDER_TARGET_STATUS,
    cell: (item: IOrderTargetItems) =>
      getDisplayExaminationOrderTargetStatus(item.examinationOrderTargetStatus),
  },
];

/**
 * 再審査指示・判定
 */
const Main = () => {
  const { examinationApplicationNo } = useParams();
  const dispatch = useAppDispatch();
  const navigator = useNavigate();
  const {
    data: apiResponse,
    isError,
    error,
    refetch,
  } = useGetReexaminationOrdersQuery(examinationApplicationNo!);
  const err: any = error;
  const isStore = APPLICATION_TYPE_STORES.includes(
    apiResponse?.applicationType ?? -1
  );

  const ORDER_TARGETS: IOrderTargetItems[] = [
    {
      orderTarget: LABELS.V_M_SMCC,
      requestDate: apiResponse?.vmsmccExaminationOrderTargetDate ?? "",
      examinationOrderTargetStatus:
        apiResponse?.vmsmccExaminationOrderTargetStatus ?? -1,
      isApplied: apiResponse?.vmsmccValidInvalidFlg,
      displayOrder: apiResponse?.vmsmccDisplayOrder ?? -1,
    },
    {
      orderTarget: LABELS.V_M_TF,
      requestDate: apiResponse?.vmtfExaminationOrderTargetDate ?? "",
      examinationOrderTargetStatus:
        apiResponse?.vmtfExaminationOrderTargetStatus ?? -1,
      isApplied: apiResponse?.vmtfValidInvalidFlg,
      displayOrder: apiResponse?.vmtfDisplayOrder ?? -1,
    },
    {
      orderTarget: LABELS.V_M_SAISON,
      requestDate: apiResponse?.vmsezonExaminationOrderTargetDate ?? "",
      examinationOrderTargetStatus:
        apiResponse?.vmsezonExaminationOrderTargetStatus ?? -1,
      isApplied: apiResponse?.vmsezonValidInvalidFlg,
      displayOrder: apiResponse?.vmsezonDisplayOrder ?? -1,
    },
    {
      orderTarget: LABELS.JCB,
      requestDate: apiResponse?.jcbExaminationOrderTargetDate ?? "",
      examinationOrderTargetStatus:
        apiResponse?.jcbExaminationOrderTargetStatus ?? -1,
      displayOrder: apiResponse?.jcbDisplayOrder ?? -1,
    },
    {
      orderTarget: LABELS.AMEX,
      requestDate: apiResponse?.amexExaminationOrderTargetDate ?? "",
      examinationOrderTargetStatus:
        apiResponse?.amexExaminationOrderTargetStatus ?? -1,
      displayOrder: apiResponse?.amexDisplayOrder ?? -1,
    },
  ];

  useLayoutEffect(() => {
    if (isError && "data" in err) {
      const { messageId, errorDetail } = err.data;
      if (messageId) {
        dispatch(
          addNotification({
            msgId: messageId,
            msgArgs: errorDetail ?? [],
          })
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiResponse]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  /**
   * 戻るボタンを押したときの処理.
   */
  const backOnClick = () => {
    navigator(`/examination-inquiry/${examinationApplicationNo}`);
  };

  return (
    <SpaceBetween direction={"vertical"} size={"l"}>
      <ExaminationInfo
        examinationApplicationNo={examinationApplicationNo ?? ""}
        applicationNo={apiResponse?.applicationNo ?? -1}
        applicationDate={apiResponse?.applicationDate ?? ""}
        applicationManager={apiResponse?.applicationManager ?? ""}
        updateDifferential={apiResponse?.updateDifferential ?? ""}
        isStore={isStore}
        registerName={apiResponse?.registerName ?? ""}
        companyName={apiResponse?.companyName ?? ""}
        corporateNumber={apiResponse?.corporateNumber ?? ""}
        merchantName={apiResponse?.merchantName ?? ""}
        contractService={apiResponse?.contractService ?? ""}
        contractRoute={apiResponse?.contractRoute}
      />

      <ReexaminationInstruction
        examinationApplicationNo={examinationApplicationNo ?? ""}
        isStore={isStore}
        columnDefinitions={columnDefinitions}
        items={ORDER_TARGETS}
        backOnClick={backOnClick}
      />
      <ExaminationResultsJudgement
        examinationApplicationNo={examinationApplicationNo ?? ""}
        isStore={isStore}
        columnDefinitions={columnDefinitions}
        items={ORDER_TARGETS}
        backOnClick={backOnClick}
      />

      <Box float={"left"}>
        <Button formAction={"none"} variant={"link"} onClick={backOnClick}>
          {COMMON_LABELS.BTNS.BACK}
        </Button>
      </Box>
    </SpaceBetween>
  );
};

export default Main;
